import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ActiveEvents, EventStatsSchema, PaginatedResponseSchema, PastEventSchema } from 'types';
import { api } from 'services';

export const usePastEventsQuery = (channelId?: string) =>
  useInfiniteQuery<AxiosResponse<PaginatedResponseSchema<PastEventSchema>>, AxiosError>(
    ['pastEvents', channelId ? { channelId } : undefined],
    async ({ pageParam }) =>
      channelId
        ? api.requests.ltv.getChannelRecordedPastEvents(channelId, pageParam)
        : api.requests.ltv.getRecordedPastEvents(pageParam),
    {
      getPreviousPageParam: data => !data.data.first && data.data.number - 1,
      getNextPageParam: data => !data.data.last && data.data.number + 1
    }
  );

export const useActiveEventsQuery = () =>
  useQuery<AxiosResponse<ActiveEvents>, AxiosError>(['activeEvents'], () => api.requests.ltv.getActiveEvents(), {
    refetchInterval: 5_000
  });

export const usePostEventStatsQuery = (eventCode: string) =>
  useQuery<AxiosResponse<EventStatsSchema>, AxiosError>(['postEventStats', { eventCode }], () =>
    api.requests.ltv.getEventStats(eventCode)
  );
